export default {
  SALES_ORDERS_LIST: "Command list",
  ADD_SALES_ORDER: "Add a command",
  ADD_SALES_ORDER_ITEM: "Line",
  SALES_ORDER_ADDED: "Added command",
  OWNER: "Owner",
  EDIT_SALES_ORDER: "Modify an order",
  SALES_ORDER_UPDATED: "Update order",
  BILLING_ADDRESS: "Billing address",
  EXPIRATION_TIME: "Expiration time",
  ITEM_TYPE: "type",
  SELECT_PRODUCTS: "Choose a product",
  SELECT_SUBSCRIPTIONS: "Choose a registration",
  SELECT_PACKAGES: "Choose a package",
  DELETE_SALES_ORDER_ITEM: "Delete the line",
  UPDATE_SALES_ORDER_ITEM: "Edit the line",
  SALES_ORDER_ITEM_DELETED: "Deleted line",
  SALES_ORDER_ITEM_ADDED: "Line added",
  SALES_ORDER_ITEM_EDITED: "Modified line",
  SEND: "Send",
  CANCEL: "Cancel",
  REFUND: "Repay",
  ADD_PAYMENT: "Add a payment",
  SALES_ORDER_SENT: "Order sent",
  SELECT_USERS: "Choose the user",
  SELECT_CUSTOMERS: "Choose",
  SELECT_ORGANIZATIONS: "Choose",
  SELECT_SUPPLIERS: "Choose the supplier",
  DELETE_THIS_SALES_ORDER: "Delete this order?",
  SALES_ORDER_DELETED: "Deleted command",
  CANCEL_SALES_ORDER_QUESTION: "Cancel the order?",
  SALES_ORDER_CANCELED: "Cancelled order",
  RECIPIENT: "Recipient",
  ISSUER: "Issuer",
  VALIDATE: "To validate",
  SALES_ORDER_VALIDATED: "Validated command",
  GENERATE_INVOICE: "Create the invoice",
  INVOICE_GENERATED: "Invoice creates",
  VIEW_INVOICE: "See the invoice",
  ADD_DELIVERY: "Add a delivery",
  DELIVERIES_STATE: "Delivery status",
  DELIVERIES_STATE_ITEM: "Product",
  DELIVERIES_STATE_ORDERED_QUANTITY: "Ordered quantity",
  DELIVERIES_STATE_DELIVERED_QUANTITY: "Delivered quantity",
  DELIVERIES_STATE_REMAINING_QUANTITY: "Quantity",
  DELIVERIES_STATE_REMAINING_QUANTITY: "Quantity",
  NOT_INVOICED: "Billing",
  NOT_DELIVERED: "To deliver",
  DELIVERED: "Livery",
  SALES_INVOICES: "Sale invoices",
  ADD_INVOICE: "Invoice",
  INVOICING_TYPE: "Billing type",
  INVOICING_TYPE_COMPLETE: "Complete",
  INVOICING_TYPE_AMOUNT: "Amount",
  INVOICING_TYPE_PRODUCT: "Product",
  INVOICING_STATUS_PENDING: "Uncharted",
  INVOICING_STATUS_PARTIALLY_INVOICED: "Partially billed",
  INVOICING_STATUS_INVOICED: "Billed",
  DELIVERY_STATUS_PENDING: "Unreserved",
  DELIVERY_STATUS_PARTIALLY_DELIVERED: "Partially delivered",
  DELIVERY_STATUS_DELIVERED: "Livery",
  INVOICING_STATUS: "Invoicing status",
  ORDER_STATUS_DRAFT: "Draft",
  ORDER_STATUS_CANCELED: "Canceled",
  ORDER_STATUS_VALIDATED: "Validated",
  ORDER_STATUS_COMPLETED: "Supplemented",
  DELIVERY_STATUS: "Status Delivery",
  INVOICE_TYPE: "Invoice type",
  INVOICE_TYPE_DOWNPAYMENT: "Downpayment invoice",
  INVOICE_TYPE_STANDARD: "Standard invoice",
  SALES_ORDER_INVOICE_ADDED: "Invoice added",
  VIEW_SALES_ORDER: "Purchase Order",

  CREATED_AT: "Created at",
};
